export enum NzbsuVersion {
  Raw = 'raw',
}
export enum TmdbVersion {
  Raw = 'raw',
}

export enum NzbCheckLastResultVersion {
  All = 'all',
}

export const NO_IMDB = '0000000';
export const NO_IMDB_ATTRIBUTE = 'processing';
